import { gql } from "@apollo/client";

export const GET_CUSTOM_METRICS = gql`
  query GetCustomMetrics {
    me {
      customMetrics {
        id
        name
        description
        accounting_mode
        data_type
        formula
        is_negative_trend_good
        isTemplate
      }
    }
  }
`;

export const CREATE_CUSTOM_METRIC = gql`
  mutation CreateCustomMetric(
    $name: String!
    $description: String!
    $accounting_mode: String!
    $data_type: MetricType!
    $formula: JSONObject!
    $is_negative_trend_good: Boolean!
  ) {
    createCustomMetric(
      name: $name
      description: $description
      accounting_mode: $accounting_mode
      data_type: $data_type
      formula: $formula
      is_negative_trend_good: $is_negative_trend_good
    ) {
      id
      name
      description
      accounting_mode
      data_type
      formula
      is_negative_trend_good
    }
  }
`;

export const UPDATE_CUSTOM_METRIC = gql`
  mutation UpdateCustomMetric(
    $id: Int!
    $name: String!
    $description: String!
    $accounting_mode: String!
    $data_type: MetricType!
    $formula: JSONObject!
    $is_negative_trend_good: Boolean!
  ) {
    updateCustomMetric(
      id: $id
      name: $name
      description: $description
      accounting_mode: $accounting_mode
      data_type: $data_type
      formula: $formula
      is_negative_trend_good: $is_negative_trend_good
    ) {
      id
      name
      description
      accounting_mode
      data_type
      formula
      is_negative_trend_good
    }
  }
`;

export const DELETE_CUSTOM_METRIC = gql`
  mutation DeleteCustomMetric($id: Int!) {
    deleteCustomMetric(id: $id)
  }
`;
